module.exports = __webpack_public_path__ + "static/media/eggs.39356e36.svg";